import { TextComponentConfig } from '../text/text-component-config.interface';

export interface DetailTableItem {
  product: TextComponentConfig;
  detail: TextComponentConfig;
}
